import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import _ from 'lodash';
import moment from 'moment';
import { ProgressBar, Table, Col, Row } from 'react-bootstrap';

import Loading from '../../../components/Loading/Loading';
import Header from '../../../components/Header/Header';

import { getForecasting } from '../ForecastingActions';

import '../Forecasting.scss';

class ForecastingDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forecasting: {
        startDate: moment().add(-5, 'days'),
        targetDate: moment().add(10, 'days')
      },
      current: {
        date: moment(),
        likelihood: '75%',
        remainingItems: 50,
        completedItems: 50,
        percentiles: [
          { likelihood: '98%', date: moment().add(15, 'days') },
          { likelihood: '95%', date: moment().add(14, 'days') },
          { likelihood: '85%', date: moment().add(12, 'days') },
          { likelihood: '70%', date: moment().add(9, 'days') },
          { likelihood: '50%', date: moment().add(6, 'days') },
          { likelihood: '30%', date: moment().add(4, 'days') }
        ]
      },
      activities: [
        {
          date: moment().add(-1, 'days'),
          likelihood: '55%',
          remainingItems: 70,
          completedItems: 30
        },
        {
          date: moment().add(-2, 'days'),
          likelihood: '45%',
          remainingItems: 75,
          completedItems: 25
        },
        {
          date: moment().add(-3, 'days'),
          likelihood: '70%',
          remainingItems: 80,
          completedItems: 20
        },
        {
          date: moment().add(-4, 'days'),
          likelihood: '65%',
          remainingItems: 90,
          completedItems: 10
        },
        {
          date: moment().add(-5, 'days'),
          likelihood: '60%',
          remainingItems: 100,
          completedItems: 0
        }
      ]
    };
  }

  componentDidMount() {
    if (this.props.routeParams && this.props.routeParams.dashboardId) {
      this.props.getData(this.props.routeParams.dashboardId, this.props.routeParams.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.routeParams !== prevProps.routeParams) {
      this.props.getData(this.props.routeParams.dashboardId, this.props.routeParams.id);
    }
    if (
      !this.props.isLoading &&
      (this.props.activities !== prevProps.activities || this.props.forecasting !== prevProps.forecasting)
    ) {
      this.setData();
    }
  }

  setData() {
    const { forecasting } = this.props;

    const activities = _.map(this.props.activities, a => ({
      ...a,
      date: moment(a.date)
    }));

    this.setState({
      forecasting: {
        startDate: moment(forecasting.startDate),
        targetDate: moment(forecasting.targetDate)
      },
      current: activities[0],
      activities: activities.slice(1)
    });
  }

  render() {
    const { isLoading, dateFormat } = this.props;
    const { current, activities, forecasting } = this.state;

    const timeProgress = current
      ? Math.round(
          (100 * (moment(current.date).unix() - moment(forecasting.startDate).unix())) /
            (moment(forecasting.targetDate).unix() - moment(forecasting.startDate).unix())
        )
      : 0;

    const itemsProgress = current
      ? Math.round((100 * current.completedItems) / (current.completedItems + current.remainingItems))
      : 0;

    return (
      <React.Fragment>
        <Helmet key="1">
          <title>{pageTitle(`Forecasting`)}</title>
        </Helmet>,
        <Header key="2" title="" showHome={true} />,
        <div key="3" className='bg_dashboard'>
          <div className='container'>
            <div className='forecasting_content'>
                          {!isLoading && !current && (
                <div>
                  <p className='no-data'> No data available </p>
                </div>
              )}

              {current && (
              
                <Row>
                  <Col sm={6}>
                    <div className='card'>
                      <h3>Current Status</h3>

                      <div className='labels'>
                        <div className='label-left'>
                          <label>Start Date</label>
                          <span>{moment(forecasting.startDate).format(dateFormat)}</span>
                        </div>
                        <div className='label-center'>
                          <label>Current Date</label>
                          <span>{moment(current.date).format(dateFormat)}</span>
                        </div>
                        <div className='label-right'>
                          <label>Target Date</label>
                          <span>{moment(forecasting.targetDate).format(dateFormat)}</span>
                        </div>
                      </div>
                      <ProgressBar now={timeProgress} />

                      <div className='table-content table-content-no-resp'>   
                        <div className='table-scroll'>
                          <table className='table'>
                            <thead className='table-head'>
                              <tr>
                                <th>Likelihood</th>
                                <th>Delivery Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {_.map(current.percentiles, p => (
                                <tr>
                                  <td>{p.likelihood}</td>
                                  <td>{moment(p.date).format(dateFormat)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className='labels'>
                        <div className='label-left'>
                          <label>Remaining</label>
                          <span>{current.remainingItems}</span>
                        </div>
                        <div className='label-center'>
                          <label>Completed</label>
                          <span>{current.completedItems}</span>
                        </div>
                        <div className='label-right'>
                          <label>Total</label>
                          <span>{current.completedItems + current.remainingItems}</span>
                        </div>
                      </div>
                      <ProgressBar now={itemsProgress} />
                    </div>
                  </Col>

                  <Col sm={6}>
                    <div className='card'>
                      <h3>Daily Forecasting Dashboard</h3>
                      
                      <div className='table-content table-content-no-resp'>       
                        <div className='table-scroll'>                    
                          <table className='table'>
                            <thead className='table-head'>
                              <tr>
                                <th>Tracking Date</th>
                                <th>Remaining Items</th>
                                <th>Likelihood</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{moment(current.date).format(dateFormat)}</td>
                                <td>{current.remainingItems}</td>
                                <td>{current.likelihood}</td>
                              </tr>
                              {_.map(activities, a => (
                                <tr>
                                  <td>{moment(a.date).format(dateFormat)}</td>
                                  <td>{a.remainingItems}</td>
                                  <td>{a.likelihood}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                
              )}
            </div>
          </div>
        </div>
        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getData: (dashboardId, id) => dispatch(getForecasting(dashboardId, id))
  };
};

const mapStateToProps = state => {
  return {
    activities: state.forecasting.activities,
    forecasting: state.forecasting.forecasting,
    isLoading: state.forecasting.loading,
    dateFormat: state.filters.dateFormat
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForecastingDashboard));
